import { environment } from './../../../../../environment/environment';
import { ContactService } from './../../../../core/services/contact/contact.service';
import { ChangeDetectorRef, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  takeUntil,
} from 'rxjs';
import Swal from 'sweetalert2';
import { CompanyService } from '@core/services/company/company.service';
import { PageEvent } from '@angular/material/paginator';
import { UserRole } from '@core/models/enums/user-role.enum';
import { ToastrService } from 'ngx-toastr';
import { PusherV2Service } from '@core/services/contact/pusherV2.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})
export class ChatComponent {
  @ViewChildren('userLink') userLinks!: QueryList<ElementRef>;

  headerClass: any;
  messages: any;
  messagesReciveds: any;
  newMessage: string = '';
  totalUsers: any;
  profil_image: any;
  last_name: any;
  first_name: any;
  users: any;
  image:any
  interv_uuid:any
  newUser: any;
  user_id:any;
  name:any;
  currentConversationUserId: number | null = null;
  currentUser: any;
  url: string = environment.baseUrl;
  profil_id: any;
  messagesSubscription!: Subscription;
  selectedUser: any;
  listMessages: any;
  dataEmployeeWithCompany: any;
  dataCompanyWithEmployees: any;
  dataAdmin: any;
  searchInputSubject = new Subject<string>();
  private unsubscribeAll: Subject<void> = new Subject();
  typeintervenant: string | null | number =
  this.localStorageService.getData('typeintervenant');
  esn_id: any;

  searchSubjectUser: Subject<string> = new Subject<string>();
  searchSubjectMessage : Subject<string> = new Subject<string>();

  pageSizeOptions = [5, 10, 20];

  pageSizeUser = 5;
  pageIndexUser = 0;
  totalPagesUser = 0
  searchUserText = ''

  pageSizeMessage = 5;
  pageIndexMessage = 0;
  totalPagesMessage = 0
  searchMessageText = ''

  userRoleEnum = UserRole
  connectedUserRole : any
  isContactedUser : boolean = false
  isNotificationSelection : boolean = false

  constructor(
    private chatService: ContactService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService , 
    private cdRef: ChangeDetectorRef,
    private toastrService: ToastrService,
    private pusherV2Service: PusherV2Service
  ) {}

  ngOnInit() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    const role = JSON.parse(this.currentUser || '{}')?.role_user_id    
    this.connectedUserRole =  this.checkUserRole(role ?  role : [UserRole.INTERVENER], null)
    this.getUrlParams()
    this.cdRef.detectChanges(); 

    if(!this.typeintervenant){
        this.getUser();
    } else{
      this.interv_uuid= JSON.parse(this.currentUser)?.uuid
    }
   
    this.initUserSearchListener();
    this.searchUsers(this.searchUserText);

    this.initMessageSearchListener();
    this.searchMessage(this.searchMessageText);

    this.pusherV2Service.listen(
      `chat.${JSON.parse(this.currentUser || '{}')?.uuid}.${this.connectedUserRole ?? ''}`,
      'message.sent',
      (data: any) => {
        this.handlePusherMsgForList(data)
        this.handlePusherMsgForDetails(data)
      }
    );
  }
formatMessage(message: string): string {
  return message.replace(/\n/g, '<br>');
}
  getUrlParams() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {

        this.name = params.params['name'];
        if(this.name) {
          this.user_id = params.params['user'];
          if (this.user_id) {
            this.searchUserText = this.name;
            this.isContactedUser = true
            this.goToUsersTab()
          } 
        } else {
          this.user_id = params.params['userId'];
          this.searchMessageText = ''
          this.isNotificationSelection = true
        }
      },
    });
  }

  getUser() {
    this.first_name = JSON.parse(this.currentUser).company.name;
    this.profil_image = JSON.parse(this.currentUser).company.logo;
    this.profil_id = JSON.parse(this.currentUser).uuid;
    this.esn_id = JSON.parse(this.currentUser).company?.uuid;
  }
  getFirstLetter(user: any): string {
    if (user?.full_name && user?.full_name?.length > 0) {
      return user?.full_name[0];
    } else {
      return '';
    }
  }

  loadMessagesEmitter(userId?: any) {    
    this.spinner.show();
    if(userId){
    const receiverRole = this.checkUserRole(this.selectedUser.role_user_id, this.selectedUser?.Role, this.selectedUser?.company_name)    
    this.chatService.getMessagesEmitter(userId, this.connectedUserRole, receiverRole).subscribe((messages) => {
      this.messages = messages?.data.reverse().map((message: any) => {
        message.elapsedTime = this.formatElapsedTime(message.created_at);
        return message;
      });      
      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastrService.error('Erreur lors du chargement des messages');
    });
  }
  }

  sendMessage() {
    const receiverRole = this.checkUserRole(this.selectedUser.role_user_id, this.selectedUser?.Role)
    if (this.newMessage.trim() !== '') {
      this.chatService
        .sendMessage(this.currentConversationUserId, this.newMessage, this.connectedUserRole, receiverRole)
        .subscribe(() => {
          this.newMessage = '';
          this.loadMessagesEmitter(this.currentConversationUserId)
          this.searchMessage(this.searchMessageText)
        });
    }
  }
  formatElapsedTime(created_at: string): string {
    const currentTime = moment();
    const messageTime = moment(created_at);
    const duration = moment.duration(currentTime.diff(messageTime));

    if (duration.asMinutes() <= 59) {
      const minutes = Math.floor(duration.asMinutes());
      if (minutes < 1) {
        return "à l'instant";
      } else if (minutes === 1) {
        return '1 minute';
      } else {
        return `${minutes} minutes`;
      }
    } else if (duration.asHours() <= 23) {
      const hours = Math.floor(duration.asHours());
      if (hours === 1) {
        return '1 heure';
      } else {
        return `${hours} heures`;
      }
    } else if (duration.asDays() <= 6) {
      const days = Math.floor(duration.asDays());
      if (days === 1) {
        return '1 jour';
      } else {
        return `${days} jours`;
      }
    } else {
      const weeks = Math.floor(duration.asDays() / 7);
      if (weeks === 1) {
        return '1 semaine';
      } else {
        return `${weeks} semaines`;
      }
    }
  }

  getListMessage() {
    this.spinner.show();
    this.chatService.getListMessage().subscribe({
      next: (res) => {
        this.listMessages = res.data;
        this.spinner.hide();
      },
      error: (e) => {
        this.spinner.hide();
      },
    });
  }
  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
  getListUserImage(user: any ): string {
    
    const  urlUser = `${this.url}/api/User/file/gallery_users/`
    const  urlCompany = `${this.url}/api/Company/file/gallery_company/`
    const hasRoleAdmin = user?.role_user_id.includes(UserRole.ADMIN_ESN) || user?.role_user_id.includes(UserRole.ESN_UNSUBSCRIBED);

    if(hasRoleAdmin){
        return urlCompany.concat(user?.image_url)
    } else {
      return urlUser.concat(user?.image_url)
    }
  }
  userSelected(user: any, isUser? : boolean) {   
    this.selectedUser = user;
    if(isUser){
      this.convertSelectedUser(user)
    }
    this.startConversation(user?.uuid);
  }

  private convertSelectedUser(user : any){
    if(this.selectedUser){
      this.selectedUser.role_user_id = user?.role_user_id
    }
  }
  getCompanyNameOfUser(user: any ): string | null {

    const rolesToCheck = [UserRole.CONSULTANT, UserRole.INTERVENER, UserRole.ADMIN_ESN, UserRole.ESN_UNSUBSCRIBED];
    const hasMatch = user?.role_user_id.some((role : any) => rolesToCheck.includes(role));

    if(hasMatch) {
      if (user?.company_name_user) {
        return user.company_name_user;
      }
      if (user?.company_name_employ) {
        return user.company_name_employ;
      }
      return '---';
    } else{
      return null
    }

  }
  startConversation(userId: any) {
    this.currentConversationUserId = userId;
    this.loadMessagesEmitter(userId);
  }


  clickUserLink(userId: string) {
    const userLink = this.userLinks.find(link => link.nativeElement.getAttribute('href') === `#userLink_${userId}`);
    if (userLink) {
      userLink.nativeElement.click();
    }
  }

  applyFilterMessage(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchInputSubject.next(filterValue);
  }

  openDeleteQuestionAlert(receiverId: any) {
    Swal.fire({
      title: `Êtes-vous sûr de vouloir supprimer cette Conversation?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
      confirmButtonColor: 'red',
      reverseButtons: true,
      iconColor: '#ff0000',
    }).then((result) => {
      if (result.isConfirmed) {
        this.toastrService.success('La conversation a été supprimée avec succès');
        this.deleteConversation(receiverId);
      }
    });
  }
  deleteConversation(receiverId: any): void {
    this.chatService.deleteConversation(receiverId).subscribe(
      (response) => {
        this.pageIndexMessage = 0
        this.searchMessage(this.searchMessageText);
        this.selectedUser = null
      },
      (error) => {
      }
    );
  }
  readMessage(id: any) {
    this.spinner.show();
    let data = { id: id };
    this.chatService
      .readMessage(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
        },
        error: (err: any) => {
          this.spinner.hide();
        },
      });
  }
  goToUsersTab() {
    const usersTab = document.querySelector('a[href="#Utilisateurs"]');
    if (usersTab) {
      (usersTab as HTMLElement).click();
    }
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }

     /**
   * Trigger search whenever the user types in the search input.
   * @param event The keyboard event from the input field.
   */
     onSearchInputUser(event: Event): void {
      const inputValue = (event.target as HTMLInputElement).value;
      this.searchSubjectUser.next(inputValue); // Emit the input value to the search subject
    }

    /**
   * Handle page change event from the paginator.
   * @param event The page event containing the new page index and page size.
   */
   onPageChange(e: PageEvent, type :string): void {   
    if(type === 'U'){
      this.pageSizeUser = e.pageSize;
      this.pageIndexUser = e.pageIndex;
      this.searchUsers(this.searchUserText);
    } else if(type === 'M'){
      this.pageSizeMessage = e.pageSize;
      this.pageIndexMessage = e.pageIndex;
      this.searchMessage(this.searchMessageText);
    }
  }

  getCompanyName(user: any ): string {
    if (user?.employee) {
      return user.employee?.company?.name;
    }
    if (user?.company) {
      return user.company?.name;
    }
    return '---';
  }

  getUserImage(user: any ): string {
    const  urlUser = `${this.url}/api/User/file/gallery_users/`
    const  urlCompany = `${this.url}/api/Company/file/gallery_company/`

    if(user?.role_user_id.includes(UserRole.ADMIN_ESN)){
        return urlCompany.concat(user?.image_url)
    } else {
      return urlUser.concat(user?.image_url)
    }
  }

  /**
   * Call the service to search users based on the search term.
   * @param searchTerm The search term entered by the user.
   */
  searchUsers(searchTerm: string): void {
    this.spinner.show();
    const requestData = { search: this.isContactedUser? this.user_id :searchTerm };

    this.chatService.searchListUser(requestData, this.pageSizeUser, this.pageIndexUser).subscribe({
      next: (result) => {
        this.spinner.hide();
        this.dataEmployeeWithCompany = result?.data || [];
        this.totalPagesUser = result?.totalElements

        if(this.name && this.user_id && this.name === this.searchUserText){
          this.dataEmployeeWithCompany = this.dataEmployeeWithCompany.filter((user: any) => user.uuid == this.user_id);
          this.userSelected(this.dataEmployeeWithCompany[0])
          this.totalPagesUser = 1
        }
      },
      error: (err) => {
        this.spinner.hide(); // Hide spinner in case of an error
        this.dataEmployeeWithCompany = [];
        this.pageIndexUser = 0;
        this.totalPagesUser = 0
      }
    });
  }


  /**
   * Call the service to search messages based on the search term.
   * @param searchTerm The search term entered by the user.
   */
  searchMessage(searchTerm: string): void {
    this.spinner.show();
    const requestData = { search: searchTerm, role_connected : this.connectedUserRole };    

    this.chatService.searchListMessage(requestData, this.pageSizeMessage, this.pageIndexMessage).subscribe({
      next: (result) => {
        this.spinner.hide();
        this.listMessages = result.data?.data || [];
        this.totalPagesMessage = result.data?.total

        if(this.isNotificationSelection) this.preSelectConversation()

      },
      error: (err) => {
        this.spinner.hide();
        this.listMessages = [];
        this.pageIndexMessage = 0;
        this.totalPagesMessage = 0
      }
    });
  }

  /**
   * Initialize the search listener to debounce user input.
   */
  private initUserSearchListener(): void {
    this.searchSubjectUser
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        this.searchUserText = searchTerm
        this.pageIndexUser = 0
        if( this.isContactedUser){
          this.isContactedUser = false
        }
        this.searchUsers(this.searchUserText);
      });
  }

   /**
   * Trigger search whenever the user types in the search input.
   * @param event The keyboard event from the input field.
   */
   onSearchInputMessage(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.searchSubjectMessage.next(inputValue);
  }

  /**
   * Initialize the search listener to debounce user input.
   */
  private initMessageSearchListener(): void {
    this.searchSubjectMessage
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        this.searchMessageText = searchTerm
        this.pageIndexMessage = 0
        this.searchMessage(this.searchMessageText);
      });
  }

  getSenderImage(message: any ): string {
    const  urlUser = `${this.url}/api/User/file/gallery_users/`
    const  urlCompany = `${this.url}/api/Company/file/gallery_company/`
    const hasRoleAdmin = message?.emitter?.role_user_id.includes(UserRole.ADMIN_ESN) || message?.emitter?.role_user_id.includes(UserRole.ESN_UNSUBSCRIBED);

    if(hasRoleAdmin){
      return urlCompany.concat(message?.emi_image_url)
    } else {
      return urlUser.concat(message?.emi_image_url)
    }
  }

  private checkUserRole(roles: string[], roleName : string | null, companyName? : string): string | null {
    if (roles?.length === 1) {
      if (roles.includes(UserRole.ADMIN_ESN)) {
        return UserRole.ADMIN_ESN;
      } else if (roles.includes(UserRole.CANDIDATE) && !companyName ) {
        return UserRole.CANDIDATE;
      } else if(roles.includes(UserRole.INTERVENER)) {
        return UserRole.INTERVENER;
      } else if(roles.includes(UserRole.ADMIN_WGU)) {
        return UserRole.ADMIN_WGU;
      } else{
        return null
      }
    }
    
    if (roles?.length === 2) {
      if (roles.includes(UserRole.CANDIDATE) && roles.includes(UserRole.CONSULTANT)) {
        return UserRole.CONSULTANT;
      } else if (roles.includes(UserRole.CANDIDATE) && roles.includes(UserRole.INTERVENER)) {
          if(roleName === 'Talent'){
            return UserRole.CANDIDATE;
          } else{
            return UserRole.INTERVENER;
          }
      }
    }
    
    return null;
  }

  private preSelectConversation(){
    if (this.user_id) {
      const viewedMessageUser = this.listMessages?.find((msg: { user: { uuid: any; }; }) => msg?.user?.uuid == this.user_id)?.user      
      this.userSelected(viewedMessageUser)
      this.isNotificationSelection = false
    } 
  }

  private handlePusherMsgForList(data : any){
    const { emitter, ...message } = data;
    emitter.Role =  emitter?.Role.replace(/_company\d*$/, '')
    const chatMessage = {
      chats : [ {...message }],
      user : {...emitter},
      new : false
    }    
    const existingIndex = this.listMessages.findIndex((msg: any) => msg.user?.uuid === chatMessage.user?.uuid);
    if (existingIndex !== -1) {
      this.listMessages.splice(existingIndex, 1);
    }
    this.listMessages.unshift(chatMessage);

    setTimeout(() => {
      chatMessage.new = true; 
    }, 10); 
  
    // Remove the effect after a few seconds
    setTimeout(() => {
      chatMessage.new = false;
    }, 5000);
  }

  private handlePusherMsgForDetails(data : any){
    const chatMessage = {
      ...data,
      emi_image_url : data?.emitter?.image_url,
      elapsedTime : this.formatElapsedTime(data?.created_at)
    }    
    this.messages?.push(chatMessage);
  }

  isTalent(roles : any[]) : boolean{   
    if (roles.length === 1 && roles.includes(UserRole.CANDIDATE)) {
      return true;
    }
    if (roles.length > 1 && roles.includes(UserRole.CANDIDATE) && roles.includes(UserRole.CONSULTANT)) {
      return true;
    }
    return false;
  }
}
